import { ImageLockOutlineIcon } from './ImageLockOutlineIcon';

/**
 * author: Simran
 * id 1F5591F3-542A-4369-9F1B-721E54C513B2
 * name image-lock-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-lock-outline.svg
 * tags
 * - Photography 
 * - Lock 
 */
export const ImageSecureOutlineIcon = ImageLockOutlineIcon;
export default ImageSecureOutlineIcon